const swiper = new Swiper('.hero-main__content.swiper', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    lazy: false,
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 10,
    pagination: {
    el: ".swiper-pagination",
    clickable: true
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    speed: 1500
});